export default __webpack_public_path__ + "static/media/alertgraphiteviperdraft_0d8ce682913d18429e04f67dc745abf4.5de01ee9.png";